import { useStyletron } from 'baseui'; // eslint-disable-next-line baseui/no-deep-imports
import { mergeOverride, toObjectOverride } from 'baseui/helpers/overrides';
import { Icon, IconProps } from 'baseui/icon';
import { h } from 'preact';
import { forwardRef } from 'preact/compat';

export default forwardRef<SVGSVGElement, IconProps>((props: IconProps, ref) => {
    const [, theme] = useStyletron();
    const { title = 'Restart', size, color, overrides = {},...restProps } = props;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    const SvgOverride = mergeOverride( // @ts-ignore
        { component: theme.icons?.ChangeCircle ? theme.icons.ChangeCircle : null },
        overrides?.Svg ? toObjectOverride(overrides.Svg) : {},
    );
    return (
        <Icon viewBox="0 96 960 960"
              ref={ref}
              title={title}
              size={size}
              color={color}
              overrides={{ Svg: SvgOverride }}
              {...restProps}>
            <path d="m482 856 114-113-114-113-42 42 43 43q-28 1-54.5-9T381 675q-20-20-30.5-46T340 577q0-17 4.5-34t12.5-33l-44-44q-17 25-25 53t-8 57q0 38 15 75t44 66q29 29 65 43.5t74 15.5l-38 38 42 42Zm165-170q17-25 25-53t8-57q0-38-14.5-75.5T622 434q-29-29-65.5-43T482 377l38-39-42-42-114 113 114 113 42-42-44-44q27 0 55 10.5t48 30.5q20 20 30.5 46t10.5 52q0 17-4.5 34T603 642l44 44ZM480 976q-83 0-156-31.5T197 859q-54-54-85.5-127T80 576q0-83 31.5-156T197 293q54-54 127-85.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 83-31.5 156T763 859q-54 54-127 85.5T480 976Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
        </Icon>
    );
});
